// src/pages/Analytics.tsx
import { BarChart, TrendingUp } from 'lucide-react';

function Analytics() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Analytics</h1>
        <p className="mt-2 text-gray-600">Insights into your job search</p>
      </div>

      <div className="bg-white rounded-lg shadow p-12 text-center">
        <BarChart className="mx-auto h-16 w-16 text-gray-400" />
        <h3 className="mt-4 text-lg font-medium text-gray-900">Coming Soon</h3>
        <p className="mt-2 text-sm text-gray-500">
          Analytics and insights will be available here to help you track your job search progress
        </p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl mx-auto">
          <div className="p-4 bg-gray-50 rounded-lg">
            <TrendingUp className="h-6 w-6 text-primary-600 mx-auto mb-2" />
            <p className="text-xs text-gray-600">Application trends</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <BarChart className="h-6 w-6 text-primary-600 mx-auto mb-2" />
            <p className="text-xs text-gray-600">Response rates</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg">
            <TrendingUp className="h-6 w-6 text-primary-600 mx-auto mb-2" />
            <p className="text-xs text-gray-600">Interview conversion</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
